import { ListItemText } from '@mui/material';
import ListItemLink from 'components/system/ListItemLink/ListItemLink';
import { TNotificationFieldsFragment } from 'generated/graphql';
import { buildNotificationUrl } from './notifications.helpers';

interface INotificationLinkItem {
  data: TNotificationFieldsFragment;
  onClick: () => void;
}

const NotificationLinkItem = ({ onClick, data }: INotificationLinkItem) => {
  return (
    <ListItemLink
      alignItems="flex-start"
      to={buildNotificationUrl(data)}
      onClick={onClick}
      // Prevent nested "li"
      defaultHtmlElement="div"
    >
      <ListItemText
        primary={data.title}
        secondary={data.description}
        primaryTypographyProps={{
          variant: 'textBase',
          sx: {
            fontWeight: data.read ? '100' : 'bold',
            color: 'primary.main',
          },
        }}
        secondaryTypographyProps={{
          variant: 'textBase',
          sx: { fontWeight: data.read ? '100' : 'bold', color: 'primary.dark' },
        }}
      />
    </ListItemLink>
  );
};

export default NotificationLinkItem;
